import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist( { key: 'authentication' } );

export const tokenState = atom( {
	key: 'authTokenState',
	default: '',
	effects_UNSTABLE: [ persistAtom ]
} );